var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 15.999,
    viewBox: "0 0 15.999 15.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parametres-curseurs",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2648",
    "data-name": "Trac\\xE9 2648",
    d: "M.667,3.166H2.491a2.485,2.485,0,0,0,4.8,0h8.045a.667.667,0,0,0,0-1.333H7.287a2.485,2.485,0,0,0-4.8,0H.667a.667.667,0,1,0,0,1.333ZM4.888,1.333A1.167,1.167,0,1,1,3.722,2.5,1.167,1.167,0,0,1,4.888,1.333Z",
    fill: "#165227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2649",
    "data-name": "Trac\\xE9 2649",
    d: "M15.332,10.083H13.508a2.485,2.485,0,0,0-4.8,0H.667a.667.667,0,0,0,0,1.333H8.713a2.485,2.485,0,0,0,4.8,0h1.824a.667.667,0,0,0,0-1.333Zm-4.222,1.833a1.167,1.167,0,1,1,1.167-1.167,1.167,1.167,0,0,1-1.167,1.167Z",
    transform: "translate(0 -2.75)",
    fill: "#165227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2650",
    "data-name": "Trac\\xE9 2650",
    d: "M15.332,18.333H7.287a2.485,2.485,0,0,0-4.8,0H.667a.667.667,0,1,0,0,1.333H2.491a2.485,2.485,0,0,0,4.8,0h8.045a.667.667,0,0,0,0-1.333ZM4.888,20.166A1.167,1.167,0,1,1,6.055,19,1.167,1.167,0,0,1,4.888,20.166Z",
    transform: "translate(0 -5.501)",
    fill: "#165227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.59dd0d9f6aa0f53457f5c4d8acf6177c.svg";
export { ForwardRef as ReactComponent };